(function (Drupal, $, once) {
    Drupal.behaviors.or32 = {
        attach() {
            $(once('or32', 'body'))
                .first()
                .each(function () {
                    const componentClass = '.OR32';
                    const carouselClass = '.OR32__slides';

                    const $carousel = $(carouselClass);

                    function getComponentInstance(context) {
                        return $(context).closest(componentClass);
                    }

                    $carousel.each(function () {
                        const $component = getComponentInstance(this);
                        // Check if slick is not initialized earlier on same element.
                        $(this)
                            .not('.slick-initialized')
                            .slick({
                                infinite: false,
                                arrows: true,
                                dots: true,
                                dotsClass: 'OR32__indicators unstyled',
                                prevArrow:
                                    '<button class="OR32__button OR32__button--previous"><span class="accessible-hide">Previous slide</span></button>',
                                nextArrow:
                                    '<button class="OR32__button OR32__button--next"><span class="accessible-hide">Next slide</span></button>',
                                appendDots: $component.find(
                                    '.OR32__indicator-container',
                                ),
                                appendArrows: $component.find(
                                    '.OR32__button-container',
                                ),
                            });
                    });
                });
        },
    };
})(Drupal, jQuery, once);
